import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      redirect: "/actief"
    },
    {
      path: "/startlijst",
      name: "StartList",
      component: () => import("./views/StartList.vue"),
      meta: {
        title: "Startlijst"
      }
    },
    {
      path: "/turflijst",
      name: "TallyList",
      component: () => import("./views/TallyList.vue"),
      meta: {
        title: "Turflijst"
      }
    },
    {
      path: "/actief",
      name: "ActiveFlights",
      component: () => import("./views/ActiveFlights.vue"),
      meta: {
        title: "Actieve vluchten"
      }
    }
  ]
});
